import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingButtonComponent {
  label = input.required<string>();
  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  icon = input<string>();
  color = input<string>('primary');
  className = input<string>('');

  clicked = output<void>();

  onClick() {
    if (!this.loading() && !this.disabled()) {
      this.clicked.emit();
    }
  }
}
